export default {
  "homeScreen": {
    "farm": "Granja",
    "label": "Seleccione Granja",
    "noFarm": "Sin granja",

    "fetchingData": "Obteniendo los datos ...",
    "pleaseWait": "Por favor espere",
    "noConnection": "No se pueden mostrar los resultados.\nVerifique su conexión y actualice la página.",

    "emptyFarm": "Aún no tienes ninguna granja",
    "emptyPond": "Aún no tienes ningún estanque.",
    "emptyCycle": "Aún no tienes ningún ciclo activo",
    "createFarm": "Crear un estanque",
    "createPond": "Crear estanque",
    "createCycle": "Iniciar un ciclo",

    "emptyFarmTitleMonitoring": "No se puede abrir el monitoreo",
    "emptyFarmTitlePond": "No puedo abrir estanques",
    "emptyFarmTitlePrediction": "No puedo abrir predicciones",
    "emptyFarmTitleAsto": "No puedo abrir Asto",
    "emptyFarmSubtitle": "Primero cree una granja para abrir esta función",
    "emptyFarmButton": "Ok",

    "predictionBiomass": "Estimación de biomasa",
    "actualFeedAccumulation": "Alimentación total",
    "predictionSR": "Estimación de TS",
    "predictionPrice": "Precio de venta",
    "predictionWeight": "Estimación MBW",
    "estimationCog": "Estimación COGS",
    "predictionRevenue": "Potencial de Ingresos",
    "estimationProductionPrice": "Est. Costo de Producción",
    "feedPrice": "Costo de Alimentación",
    "from": "de ",
    "activePonds": " estanques activos",

    "disclaimer": "Datos completos de alimentación y muestreo para mejorar la precisión de la estimación.",

    "tooltipSkip": "Saltar",
    "tooltipNext": "Próximo",

    "monitoring": "Vigilancia",
    "pond": "estanques",
    "finance": "Finanzas",
    "price": "Precio",
    "news": "Noticias",
    "disease": "Enfermedad",
    "asto": "Asto",
    "predictions": "Predicciones",
    "beta": "Beta",
    "autoFeeder": "Aual alimentador",
    "shrimpPrice": "Precio del camarón",
    "appMenusTitle": "Pruebe más funciones",
    "seeAll": "Ver todo",
    "shrimpNews": "Noticias de camarones",
    "consultTitle": "Necesito consultar?",
    "consultSubtitle": "Ahora puedes consultar sobre agricultura a través de la app.",
    "consultButton": "Pregunta ahora",
    "youtubeTutorial": "Mira el tutorial de la aplicación Jala",
    "helpTutorial": "Ayuda",
    "telegramTutorial": "Únase al grupo de discusión",
    "bannerTitle": "Otra solución de cultivo de camarones",
    "bottomTitle": "Tutorial de Cultivo con JALA App",
    "overview": "Visión general",
    "partner": "Jala socio",
    "notifications": "Notificación",
    "simulation": "Simulación",
    "chemicalPredictions": "Predicciones de Química",
    "newLabel": "nuevo",
    "activity": "Actividad",

    "startCultivationTitle": "Administre su granja camaronera con Jala",
    "startCultivation": "Iniciar el Cultivo",

    "alertNoFarmTitle": "Necesitas tener Granja",
    "alertNoFarmDescription": "Se puede acceder a Información Rapida si ya cuenta con una granja.",
    "alertNoActiveCycleTitle": "No hay ciclo activo",
    "alertNoActiveCycleDescription": "Inicie un ciclo para ingresar el registro.",
    "alertStartCultivationTitle": "Cambiar al modo de cultivo",
    "alertStartCultivationDescription": "Para acceder a las funciones de cultivo, cambie la configuración en: Cuenta - Ayuda - Mostrar personalización - luego seleccione Administrar cultivo.",

    "reminderActivity": "Presiona para completar tu tarea",
    "pro": "Pro",

    "occupationModalTitle": "Hola {{user}}!",
    "occupationModalSubtitle": "Complete los datos de su perfil para obtener una mejor experiencia con las aplicaciones JALA",

    "offline": "Sin Conexión"
  },

  "modelCreateScreen": {
    "areYouSure": "¿Quiere borrar?",
    "areYouSureYouWantToSomething": "¿Quiere borrar %{something}?",

    "deleteSomething": "eliminar %{something}",
    "thisData": "este registro"
  },

  "farmCreateScreen": {
    "title": "Crear Granja",

    "disconnectedModalTitle": "No está Conectado",
    "disconnectedModalSubtitle": "La aplicación ha detectado una conexión débil, asegúrese de estar conectado a Internet"
  },
  "farmEditScreen": {
    "title": "Configuración de la Granja",
  },

  "pondCreateMultipleScreen": {
    "title": "Crear Estanque"
  },

  "cycleCreateMultipleScreen": {
    "title": "Iniciar Ciclo",

    "deleteCycle": "Eliminar Ciclo",
    "deleteCycleSubtitle": "No pudiste acceder al ciclo eliminado",
    "deleteCycleModalTitle": "¿Está seguro?",
    "deleteCycleModalSubtitle": "No podrá acceder a sus ciclos eliminados.",
  },

  "farmShrimpPriceCreateScreen": {
    "title": "Configuración de precios de venta",
  },

  "overviewScreen": {
    "setting": "Configuración",
    "total": "Total",
    "average": "Promedio",
    "fromActivePonds": "de %{count} estanques activos",
    "disclaimer": "Datos completos de alimentación y muestreo para mejorar la precisión de la estimación.",
    "fixDisclaimer": "Complete los datos de su feed para obtener una estimación más cercana a la real.",
    "disclaimerWithPond": "Complete los datos de alimentación para {{ponds}} ",
    "disclaimerButton": "y otros {{number}} estanques ",
    "disclaimerWithPondEnd": "para mejorar la precisión de la estimación."
  },
  
  "overviewTotalWeightPredictionListScreen": {
    "title": "Estimación de biomasa",
    "subtitle": "Estimación de biomasa total",
  },
  "overviewHarvestAccumulationWeightActualListScreen": {
    "title": "Cosecha total",
    "subtitle": "Cosecha total",
  },
  "overviewFeedAccumulationActualListScreen": {
    "title": "Alimentación total",
    "subtitle": "Alimentación total",
  },
  "overviewSurvivalRatePredictionListScreen": {
    "title": "Estimación de TS",
    "subtitle": "Estimación de SR promedio",
  },
  "overviewSellingPricePredictionListScreen": {
    "title": "Estimación del precio de venta",
    "subtitle": "Estimación del precio de venta total",
    "source": "Fuente de precio de venta: "
  },
  "overviewFeedCostListScreen": {
    "title": "Costo de Alimentación",
    "subtitle": "Costo total de alimentación",
    "pond": "Estanque (DoC)",
    "feedCost": "Costo de alimentación",
    "feed": "Alimentación (kg)",
    "moreInfo": "Más información",
    "price": "Precio de alimentación",
    "infoCostFormula": "Costo del alimento = alimento total x precio del alimento",
    "disclaimer": "*Este valor estimado es sólo una información alternativa para evaluar los aspectos operativos del cultivo y aún no está conectado a las funciones financieras en la aplicación web JALA.",
    "infoPriceText": "El precio del alimento se obtiene de la configuración al crear un ciclo. Puede cambiar el precio del alimento a través del menú de configuración del ciclo en cada estanque.",
    "infoPriceText2": "Lista de piscinas > Página de estanque > menú de la esquina derecha",
  },
  "overviewProductionCostEstimationListScreen": {
    "title": "Estimación de Costos de Producción",
    "infoCostFormula": "Estimación de costos de producción = costos de semillas + costo de alimentación + otros costos estimados",
    "subtitle": "Estimación de costo total de producción",
    "pond": "Estanque (DoC)",
    "productionCost": "Costo\nde producción ({{currency}})",
    "feedCost": "Costo de alimentación ({{currency}})",
    "otherCost": "Otro\ncosto ({{currency}})",
    "infoPriceTitle": "Costo de producción estimado",
    "infoPriceTitle2": "Estimación de otros costos",
    "infoPriceText": "Las estimaciones de los costos de producción se obtienen de la suma de los costos de alimentación, la estimación de los costos de las semillas y la estimación de otros costos.",
    "infoPriceText2": "Otras estimaciones de costos se obtienen del 10% al 40% de los costos de alimentación que se ajustan a la duración del cultivo (DoC).",
    "disclaimer": "*Este valor estimado es sólo una información alternativa para evaluar los aspectos operativos del cultivo.",
    "disclaimerElectricCost": "*<b>Costos de electricidad</b>, <b>salario de empleado</b> y <b>costos de preparación del cultivo</b> no incluido en el cálculo de la estimación.",
    "feedbackInfo": "Tiene una queja sobre los resultados de la estimación?",
    "submitFeedback": "Dar Opinion",
    "infoPriceText3": "Este cálculo no está relacionado con las funciones financieras de la aplicación web JALA.",
  },
  "overviewRevenuePotentialListScreen": {
    "title": "Potencial de Ingresos",
    "subtitle": "Ingresos potenciales totales",
    "pond": "Estanque (DoC)",
    "harvest": "Cosecha ({{currency}})",
    "revenuePotential": "Potencial de ingresos",
    "biomassEst": "Est. biomasa (kg)",
    "surcePrice": "Fuente de los precios de venta del camarón:",
    "sellingPrice": "Precio de venta de camarones: ",
    "latestShrimpPrice": "Últimos precios de camarones",
    "manualShrimpPrice": "Establecer manualmente",
    "settingShrimpPrice": "Establecer el precio de venta",
    "notConnectedPrice": "No conectado todavía",
    "infoCostFormula": "Ingresos potenciales = (biomasa estimada x precio de venta del camarón) + cosecha ({{currency}})",
    "disclaimer": "*Este valor estimado es sólo una información alternativa para evaluar los aspectos operativos del cultivo y aún no está conectado a las funciones financieras en la aplicación web JALA..",
    "warningInfo": "Complete sus datos de alimentación para obtener una estimación más precisa."
  },
  "overviewHPPEstimationListScreen": {
    "title": "Cogs Estimación",
    "infoCostFormula": "Cogs Estimación =",
    "infoCostFormula2": "Estimación de costos de producción ({{currency}})",
    "infoCostFormula3": "Estimación de estanque de biomasa + cosecha (kg)",
    "subtitle": "Costo promedio de los bienes vendidos. {{currency}}/kg",
    "perKg": "/kg",
    "pond": "Estanque (DoC)",
    "estHpp": "Cogs Est. ({{currency}}/kg)",
    "estBiomassa": "Biomasa Est. (kg)",
    "disclaimer": "*Este valor estimado es sólo una información alternativa para evaluar los aspectos operativos del cultivo y aún no está conectado a las funciones financieras en la aplicación web JALA.",
  },
  "overviewProfitPotentialListScreen": {
    "title": "Potencial de Beneficio",
    "subtitle": "Beneficio potencial total",
    "pond": "Estanque (DoC)",
    "estProfit": "Est. Beneficio ({{currency}})",
    "estRevenue": "Est. ganancia\n({{currency}})",
    "estProductionCost": "Est. costo\nde producción ({{currency}})",
    "moreInfo": "Más información",
    "infoCostFormula": "Potencial de ganancias = potencial de ingresos - costo total estimado",
    "infoPriceTitle": "Costos de producción estimados",
    "infoPriceTitle2": "Otras estimaciones de costos",
    "infoPriceText": "Los costos de producción estimados se obtienen de la suma de los costos de alimentación y otros costos estimados.",
    "infoPriceText2": "Otras estimaciones de costos se obtienen del 10% al 40% de los costos de alimentación que se ajustan a la duración del cultivo (DoC).",
  },

  "shrimpPriceScreen": {
    "listShrimpPrice": "Lista de precios de camarones",
    "size": "Talla",
    "close": "Cerca",
    "country": "País",
    "location": "Ubicación",
    "update": "Actualización de precios",
    "all": "Todos",
    "verified": "Verificado",
    "unverified": "Inconfirmado",
    "supplier": "Proveedor",
    "findLoc": "Encontrar ubicacion",
    "cancel": "Cancelar",
    "latest": "El mas nuevo",
    "week": "> 1 semana",
    "month": "> 1 Mes",
    "createPrice": "Hacer precio de camarones",
    "createPriceButton": "Hacer un precio",
    "name": "Nombre",
    "phone": "Número de teléfono móvil",
    "species": "Especies",
    "province": "Provinsi",
    "city": "ciudad del condado",
    "next": "Próximo",
    "save": "Ahorrar",
    "shrimpPriceList": "Lista de precios de camarones",
    "createdAt": "Fecha",
    "date": "Fecha",
    "currency": "Divisa",
    "currencyId": "Divisa",
    "sizeInput": "Tamaño Precio",
    "remark": "Notas (opcional)",
    "disclaimer": "Por la presente asumo la responsabilidad por la información de precios de camarones que hago y publico en Jala",
    "size200": "Tamaño 200",
    "size190": "Tamaño 190",
    "size180": "Tamaño 180",
    "size170": "Tamaño 170",
    "size160": "Tamaño 160",
    "size150": "Tamaño 150",
    "size140": "Tamaño 140",
    "size130": "Tamaño 130",
    "size120": "Tamaño 120",
    "size110": "Tamaño 110",
    "size100": "Tamaño 100",
    "size90": "Tamaño 90",
    "size80": "Tamaño 80",
    "size70": "Tamaño 70",
    "size60": "Tamaño 60",
    "size50": "Tamaño 50",
    "size40": "Tamaño 40",
    "size30": "Tamaño 30",
    "size20": "Tamaño 20",

    "size150Placeholder": "Precio de entrada",
    "size140Placeholder": "Precio de entrada",
    "size130Placeholder": "Precio de entrada",
    "size120Placeholder": "Precio de entrada",
    "size110Placeholder": "Precio de entrada",
    "size100Placeholder": "Precio de entrada",
    "size90Placeholder": "Precio de entrada",
    "size80Placeholder": "Precio de entrada",
    "size70Placeholder": "Precio de entrada",
    "size60Placeholder": "Precio de entrada",
    "size50Placeholder": "Precio de entrada",
    "size40Placeholder": "Precio de entrada",
    "size30Placeholder": "Precio de entrada",
    "size20Placeholder": "Precio de entrada",

    "datePlaceholder": "Elija fecha",
    "remarkPlaceholder": "Ejemplo : Precio BS 60 % del precio normal",
    "currencyPlaceholder": "Elegir...",
    "currencyIdPlaceholder": "Elegir...",
    "namePlaceholder": "Su nombre",
    "phonePlaceholder": "-",
    "speciesPlaceholder": "Elegir...",
    "countryPlaceholder": "Elegir...",
    "provincePlaceholder": "Elegir...",
    "provinceLabel": "Elegir Provinsi",
    "cityPlaceholder": "Elegir...",
    "sizePlaceholder": "Nominal",
    "partner": "JALA socio",
    "priceList": "Lista de precios",
    "contact": "Contacto",
    "seeContact": "DETALLES DE CONTACTO",
    "anotherPrice": "Precio Otra Región",
    "implement": "Implementar",

    "dateValidation": "La fecha debe ser completada",
    "currencyValidation": "La moneda debe ser llenada",
    "sizeValidation": "El tamaño 100 debe llenarse",
    "phoneValidationLength": "El formato del teléfono no es válido",
    "selectAll": "SELECCIONAR TODO"
  },

  "shrimpPriceListScreen": {
    "title": "Precio del Camarón",

    "listShrimpPrice": "Lista de Precios de Camarones",
    "createPrice": "Hacer Precio",
    "partner": "JALA Socio",
    "listEmptyTitle": "Shrimp prices in the location you are looking for can't be found.",
    "listEmptySubtitle": "Try to find other locations to find shrimp prices.",
    "searchLocation": "Encontrar Ubicacion",
  },
  "shrimpPriceDetailScreen": {
    "title": "Precio del Camarón",

    "unverified": "Inconfirmado",
    "verified": "Verificado",
    "partner": "JALA Socio",

    "contact": "Contacto",
    "seeContact": "Llamar",

    "priceList": "Lista de Precios",
    "anotherPrice": "Precio Otra Región"
  },

  "waterQualityMultiMeasurementCreateScreen": {
    "title": "Agregar datos de Calidad del Agua"
  },
  "waterQualityMultiMeasurementEditScreen": {
    "title": "Editar datos de Calidad del Agua"
  },
  "feedCreateScreen": {
    "title": "Agregar registro de Alimentación"
  },
  "feedEditScreen": {
    "title": "Editar datos de Alimentación"
  },
  "feedingTrayControlCreateScreen": {
    "title": "Agregar datos de La bandeja de Alimentación"
  },
  "feedingTrayControlEditScreen": {
    "title": "Editar datos de La bandeja de Alimentación"
  },
  "mortalityCreateScreen": {
    "title": "Agregar datos de mortalidad"
  },
  "mortalityEditScreen": {
    "title": "Editar datos de Mortalidad"
  },
  "chemicalMultiMeasurementCreateScreen": {
    "title": "Agregar datos Químicos"
  },
  "chemicalMultiMeasurementEditScreen": {
    "title": "Editar datos Químicos"
  },
  "planktonMultiMeasurementCreateScreen": {
    "title": "Agregar datos de Plancton"
  },
  "planktonMultiMeasurementEditScreen": {
    "title": "Editar datos de Plancton"
  },
  "microbiologyMultiMeasurementCreateScreen": {
    "title": "Agregar datos de Microbiología"
  },
  "microbiologyMultiMeasurementEditScreen": {
    "title": "Editar datos de Microbiología"
  },
  "cycleDiseaseListScreen": {
    "seeRelatedDiseaseInfo": "Ver información relacionada con la enfermedad"
  },
  "cycleDiseaseCreateScreen": {
    "title": "Agregar datos",
    "seeDiseaseInfo": "Ver información de la enfermedad"
  },
  "cycleDiseaseEditScreen": {
    "title": "Editar datos",
    "seeDiseaseInfo": "Ver información de la enfermedad"
  },
  "cycleEditScreen": {
    "title": "Editar datos del ciclo"
  },

  "cycleHarvestListScreen": {
    "closeCycle": "Cerrar ciclo"
  },

  "cycleCloseScreen": {
    "title": "Cerrar ciclo"
  },
  "cycleCloseMultipleScreen": {
    "title": "Cerrar Ciclo Múltiple"
  },
  "cycleGraphScreen": {
    "title": "Gráfico de Ciclo"
  },
  "financeScreen": {
    "title": "Finanzas",
    "ongoingFeatureTitle": "¡Jali está trabajando en algo nuevo!",
    "ongoingFeatureSubtitle": "Gracias por usar JALA App. Esta característica aún está en desarrollo. Los miembros Platinum y los usuarios de Pro Cycle pueden utilizar la función de finanzas en la aplicación web Jala.",
    "openWeb": "Abrir aplicación web",
    "learnProCycle": "Conoce sobre el Ciclo Pro",
  },
  "simulationScreen": {
    "title": "Simulación",
    "emptyTitle": "No hay simulación",
    "emptySubtitle": "La simulación guardada se mostrará aquí.",
    "biomassHeader": "Biomasa (kg)",
    "priceHeader": "Precio total",
    "createSimulation": "Crear simulación",
    "listTitle": "Lista de simulación",
    "totalSeed": "semilla total",
    "survivalRate": "Objetivo de tasa de supervivencia",
    "biomassEstimation": "Estimación de biomasa",
    "edit": "Editar",
    "delete": "Borrar",
    "name": "Datos del nombre de la simulación",
    "wide": "Granja amplia (m²)",
    "date": "Fecha",
    "seed": "Semilla total",
    "periode": "Período de cosecha",
    "maxBiomass": "Biomasa máxima (kg/m²)",
    "survival": "Stasa de supervivencia (%)",
    "size100": "Tamaño en Días 100 (tail/kg)",
    "feedPrice": "Precio de alimentación por kg",
    "currency": "Divisa",
    "addPartial": "Agregar Plan Parcial",
    "partialPlan": "Plan Parcial",
    "age": "Años (días)",
    "percent": "Por ciento",
    "addPlan": "Agregar plan",
    "cancel": "Cancelar",
    "show": "Espectáculo",
    "inputTitle": "Datos de simulación de entrada",
    "inputAge": "Edad de entrada",
    "inputPercent": "Porcentaje de entrada",
    "SimulationTabTitle": "Resultados de la simulación",
    "HarvestPriceDisclaimer": "El precio total de la cosecha aún está vacío porque la tabla de precios aún no se ha llenado.",
    "inputPrice": "Tabla de precios de entrada",
    "priceSimulation": "Simulación de precios de camarones",
    "locationDisclaimer": "Elija la ubicación para obtener su simulación de precios de cosecha.",
    "location": "Ubicación",
    "chooseLocation": "Elegir filtro de ubicación",
    "inputPriceTag": "Precio de entrada",
    "FeedTabTitle": "Proyección de salida de alimentación",
    "FeedChartTitle": "Alimentación (kg)",
    "FeedPerfectData": "Alimentación TS 100% (kg)",
    "BiomassChartTitle": "Biomasa Total Viva",
    "BiomassChartLegend": "Biomasa Total Viva (ton)",
    "BiomassMaxPerArea": "Biomasa Max por área (ton)",
    "BiomassPerfectData": "Biomasa total TS 100% (ton)",
    "FeedPriceTotal": "Precio de alimentación total",
    "seeFeedTab": "Ver tabla de alimentación",
    "deleteTitle": "Eliminar simulación?",
    "deleteSubtitle": "¿Estás seguro de eliminar? {{simulation}}?",
    "namePlaceholder": "Simulation {{date}}",
    "widePlaceholder": "1000 m²",
    "seedPlaceholder": "100000 tail",
    "periodePlaceholder": "120 fecha",
    "biomassPlaceholder": "1,2 kg/m²",
    "survialPlaceholder": "100%",
    "sizePlaceholder": "45",
    "feedPlaceholder": "Rp 15000",
    "currencyPlaceholder": "Indonesia",
    "showPrice": "Ver Precios",
    "save": "Guardar simulación",
    "searchSimulation": "Lista de simulación de búsqueda...",
    "showBiomasstable": "Mostrar tabla de biomasa",
    "biomasAxisY": "Acumulación de alimentación 100% SR (toneladas)",
    "axisX": "Días",
    "feedAxisY": "100% SR Alimento (kg)",
    "TotalHarvest": "Cosecha Total",
    "quantityShort": "cola",
    "HarvestTab": "Cosecha",
    "FeedTab": "Alimentación",
    "BiomassTab": "Biomasa",
    "DateDOCHeader": "Fecha (DoC)",
    "Size": "Talla",
    "TotalBiomass": "Biomasa total (kg)",
  },
  "customFRScreen": {
    "title": "Editar tabla FR",
    "create": "Crea tu mesa FR",
    "here": "aquí"
  },
  "parameterListScreen": {
    "title": "Lista de parámetros",
    "info": "Solo puede elegir 3 parámetros para visualizar en la aplicación móvil. Para ver todos los registro, acceda a través de la aplicación web (https://app.jala.tech)",
    "chemical": "Químico",
    "plankton": "Plancton",
    "microbio": "Microbiología"
  },
  "cycleToDoScreen": {
    "title": "Actividad Diaria",
    "empty": "Aún no hay actividad",
    "emptyFarm": "Esta función no está disponible porque no tienes una granja.",
    "emptyPond": "Esta función no está disponible porque no tienes un estanque.",
    "emptyCycle": "Esta función no está disponible porque no tienes un ciclo activo",
    "infoTitle": "Función para hacer",
    "info": "Le ayuda a administrar sus actividades diarias de cultivo y facilita como recordatorio registrar los datos de cultivo todos los días. Puede completar las actividades diarias registrando los datos de cultivo diarios de acuerdo con las actividades disponibles, como la alimentación, el control de la calidad del agua, el tratamiento y la cosecha.",
    "feeding": "Alimentación",
    "measuring": "Comprobación de la calidad del agua",
    "treatment": "Dar tratamiento",
    "feeding_tray_control": "Comprobación de la bandeja de alimentación",
    "sampling": "Comprobación de muestras",
    "mortality": "Registro de mortalidad",
    "harvest_partial": "Cosecha parcial",
    "harves_total": "Cosecha total",
    "inputDoc": "Rango de DoC de entrada",
    "until": "Hasta que",
    "addActivity": "Agregar actividad",
    "addActivityNote": "¿Está seguro de que desea agregar {{activity}} a su actividad diaria??",
    "incomplete": "Incompleto",
    "missed": "Omitido",
    "complete": "Completo",
    "closed": "Ciclo cerrado",
    "seeOthers": "Ver actividad de otros",
    "seeLess": "Ver Menos",
    "changeActivityStatus": "Cambiar estado de actividad",
    "setting": "Configuración de actividad",
    "changeStatus": "Cambiar Estado",
    "saveSetting": "Guardar configuración",
    "morningRecord": "Control de la mañana",
    "eveningRecord": "Cheque de la tarde",
    "settingWarning": "La actividad seleccionada aparecerá en su página de actividad diaria.",
    "settingTitle": "Agregar actividad diaria",
    "rangeDoc": "Se requiere el rango DoC",
    "rangeDocMax": "Rango DoC no más de 130",
    "rangeDocFrom": "De DoC",
    "rangeDocTo": "Hasta que DoC",
    "lessThan130": "{{field}} el rango debe ser inferior a 130",
    "emptySearchTitle": "Estanque no encontrado",
    "emptySearchSubtitle": "Use diferentes palabras clave de búsqueda para encontrar el estanque que está buscando",
    "functionDescription": "Función descriptiva",
    "infoDescription": "Guía de actividades diarias",
    "refreshDescription": "Actualizar los datos de la actividad diaria",
    "searchDescription": "Campo de búsqueda del nombre del estanque",
    "incompleteDescription": "Las actividades diarias están incompletas.",
    "completeDescription": "Las actividades diarias están completas.",
    "hiddenDescription": "Ocultar actividades diarias que no se están realizando actualmente",
    "changeStatusDescription": "Cambiar el estado de la actividad diaria si hay un error",
    "settingDescription": "Aumentar o disminuir la actividad diaria"
  },
  "chemicalParameterScreen": {
    "emptyHistoryParameterTitle": "Completa tus Datos de Registro",
    "emptyHistoryParameterMessage": "Para conocer las predicciones químicas, debe registrar los datos de alimentación y los parámetros físicos (pH, Salinidad, Temperatura, DO).",
    "completeData": "Datos Completos",
    "emptyMessageNewUser": "No se puede acceder a esta función porque aún no tiene un ciclo activo.",
    "gotoProTitle": "Obtenga cálculos de predicción química simplemente registrando datos de alimentación y calidad física del agua (pH, salinidad, temperatura y OD).",
    "gotoProMessage": "JALA lo ayuda a predecir datos químicos en función de los datos que registra en la aplicación.",
    "buttonGotoPro": "Actualizar ahora",
    "lowAccuracyTitle": "Precisión de predicción no óptima",
    "lowAccuracyMessage": "Registro completo de datos de alimentación y\nparámetros físicos (pH, salinidad, temperatura,\nDO).",
    "latestUpdateText": "Últimos datos {{date}}",
    "parameter": "Parámetro",
    "actualValueToday": "Actual (DoC {{age}})",
    "estimateValueToday": "Estimación (DoC {{age}})",
    "estimateValueDoC": "Estimación final\n(DoC {{age}})",
    "week": "7 Días",
    "month": "30 Días",
    "cycle": "1 Ciclo",
    "lowAccuracyPredictionMessage": "Datos completos de alimentación y parámetros físicos (pH, salinidad, temperatura, DO) ",
    "emptyPredictionMessage": "No se puede generar la predicción. Ingrese el registro de <b>datos de alimentación</b> y <b>parámetros físicos</b> para mostrar la predicción. ",
    "showDetail": "Ver detalles",
    "alkalinity": "Alkalinity",
    "hardness": "Hardness",
    "otherParameter": "Otros parámetros",
    "carbonate": "CO³",
    "bicarbonate": "HCO³",
    "calcium": "Ca",
    "magnesium": "Mg",
    "ammonia": "Ammonia",
    "nitrite": "Nitrit",
    "nitrate": "Nitrat",
    "tom": "TOM",
    "total": "Total",
    "data": "Data",
    "beta": "Beta",
    "readDescription": "Read Explanation",
    "sendFeedback": "Give Feedback",
    "alertBeta": "Esta función aún se encuentra en fase de prueba (versión beta)\n<description> o <feedback>.",
    "buttonBetaCard": "Aplicar Para Convertirse en un Probador Beta",
    "titleBetaCard": "Obtenga cálculos de predicción química simplemente registrando datos de alimentación y calidad física del agua (pH, salinidad, temperatura y OD).",
    "messageBetaCard": "Esta función aún se encuentra en fase de prueba y solo tiene acceso limitado. Si está interesado en probarlo y enviar comentarios, envíelo usted mismo a través del botón a continuación.",
    "titleBetaSheet": "Predicción de parámetros químicos",
    "content1BetaSheet": "Con esta función, puede predecir los datos de calidad del agua, especialmente los parámetros químicos, y puede usarlos como un medio alternativo para determinar el tratamiento adecuado para mantener siempre la estabilidad de la calidad del agua en la piscina.",
    "content2BetaSheet": "Esta predicción se puede mostrar cuando hay un registro de datos en la aplicación que incluye datos de alimentación acumulativos y parámetros físicos de calidad del agua (pH, salinidad, temperatura y OD).",
    "content3BetaSheet": "Las predicciones son hechas por un motor de inteligencia artificial que estudia la calidad del agua, el clima y las condiciones de entrada de alimentos a partir de varios datos sobre estanques de acuicultura de camarones en Indonesia.",
    "subtitle1BetaSheet": "¿Qué parámetros se pueden predecir?",
    "subtitle2BetaSheet": "¿Cómo funciona esta característica?",
    "subtitle3BetaSheet": "¿Cómo generar las predicciones?",
    "note1BetaSheet": "Nos damos cuenta de que este cálculo aún necesita mejoras, por lo que su aporte significa mucho para nosotros.",
    "note2BetaSheet": "<b>Nota:</b> esta predicción no considera otros factores como el clima, el color del agua, el sifón y otros.",
    "emptyDataTitle": "Valor de predicción no mostrado",
    "emptyDataMessage": "Las predicciones químicas se mostrarán si los datos de registro de alimentos y los parámetros físicos (pH, salinidad, temperatura, OD) están disponibles durante al menos los últimos 3 días",
    "emptyCycle": "No se puede acceder a esta función porque aún no tiene un ciclo activo."
  },
  "gotoJalaProScreen": {
    "buttonText": "JALA Apps Pro",
    "title": "Más Profesional con\n",
    "description": "Administre los datos de cultivo con características más completas para convertirse en información completa y útil.",
    "benefitTitle1": "Entradas de Excel",
    "benefitDesc1": "Recopile la entrada de datos de cultivo en un formato más familiar.",
    "benefitTitle2": "Gestión Financiera",
    "benefitDesc2": "Administre y controle los ingresos y gastos del estanque.",
    "benefitTitle3": "Stock de Estanque",
    "benefitDesc3": "Gestione y controle el estado de su estanque.",
    "benefitTitle4": "Informe de Cultivo",
    "benefitDesc4": "Genere informes de cultivo automáticos con análisis completo.",
    "benefitTitle5": "Predicciones Químicas",
    "benefitDesc5": "Obtenga predicciones de datos químicos aprovechando la tecnología de AI.",
    "readMore": "Lea mas en ",
    "urlJalaPro": "https://jala.tech/pro",
    "upgradeNow": "Actualizar ahora",
    "upgrade": "Actualizaciones",
  }
}
